import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const styles = theme => ({
    chipContainer:{
        display: 'inline-block',
        marginRight: 10,
    },
    number:{
        color: '#b8cde3',
        fontSize: 10,
    },
    icon:{
        position: 'absolute',
        color: '#e6edf5',
        marginLeft: -12,
        fontSize: 18,
        zIndex: -1,
    }
});

function ChipTagStatus(props) {

    const { classes, number  } = props;

    return (
        <div className={classes.chipContainer}>
            <span className={classes.number}>
                {number}
            </span>
            <FontAwesomeIcon className={classes.icon} icon={['fas', 'circle']} />
        </div>
    );
}

export default withStyles(styles)(ChipTagStatus);